<template>
  <div class="main">
    <!-- DATA E UNIDADE -->
    <!-- Mensagem de aviso para usuários LDC sobre consolidação de dados -->
    <!-- <span v-if="isLDC && (isLDC == 'true' || isLDC == true)" class="info-ldc">**Os dados podem não estar consolidados,
      por favor aguardar 30 minutos após final do turno.</span> -->
    <section>
      <div>
        <h1>Fechamento do Turno</h1>
      </div>
      <div class="occurrence-date">
        <div class="select-Indicators">
          <label for="date-picker">{{ $t('productionDate') }}</label>
          <input type="date" id="date-picker" class="sru-date-input input-pentagro" v-model="productionDateISO" />

          <label class="mt-3" for="unit-production">{{ $t('worshiftArea') }}</label>
          <select :disabled="!areaList.length" class="form-control input-pentagro" id="unit-production"
            v-model="monitoringGroup" @change="clearIndicators">
            <option default :value="null" disabled="disabled">{{ $t('screenSelectPlaceholder') }}</option>
            <option v-for="(a, i) in this.areaList" :key="i" :value="a">{{ a }}</option>
          </select>
        </div>

        <b-form-group class="select-workshift" :label="$t('workShiftSubtitle')" v-slot="{ ariaDescribedby }">
          <b-form-radio id="shiftA" v-model="selectedWorkshift" :aria-describedby="ariaDescribedby" name="some-radios"
            value="1">{{ workshiftDescriptions[1] }}</b-form-radio>
          <b-form-radio id="shiftB" v-model="selectedWorkshift" :aria-describedby="ariaDescribedby" name="some-radios"
            value="2">{{ workshiftDescriptions[2] }}</b-form-radio>
          <b-form-radio id="shiftC" v-model="selectedWorkshift" :aria-describedby="ariaDescribedby" name="some-radios"
            value="3">{{ workshiftDescriptions[3] }}</b-form-radio>
          <b-form-radio id="shiftDay" v-model="selectedWorkshift" :aria-describedby="ariaDescribedby" name="some-radios"
            value="4">{{ workshiftDescriptions[4] }}</b-form-radio>
        </b-form-group>


        <div class="seachButtonGroup">
          <img v-if="!loadingReport" @click="this.loadOccurrenceConfig" id="search-button" src="../../assets/buscar.png"
            :title="$t('search')" alt="buscar_indicadores" />
          <span v-else class="spinner-border spinner-border-sm spinnerConfig" role="status" aria-hidden="true"></span>
        </div>
      </div>
    </section>
    <!-- / DATA E UNIDADE -->

    <!-- SELECIONE UM INDICADOR -->
    <section class="mt-3" v-if="this.indicators.length > 0">
      <div class="row">
        <div class="col-12">
          <div class="title-filter">
            <div class="filtersContent">
              <div id="filter-box">
                <p class="h6">{{ $t('selecione-um-indicador-0') }}</p>
                <label class="">{{ $t('workShiftFilter') }}</label>
                <input class="ml-1 mb-1 input-pentagro" v-model="filter" />
              </div>

              <div class="selectors">
                <p class="h6">{{ $t('deviationType') }}</p>
                <div>
                  <b-form-checkbox v-model="openTriggerType">Aberta por Gatilhos</b-form-checkbox>
                  <b-form-checkbox v-model="openSpecifyType">Fora da Meta de Aderência</b-form-checkbox>
                </div>
              </div>
            </div>
          </div>

          <div class="div-table">
            <table id="table-outOfSpecificationTableIndicator" class="table table-hover table-striped">
              <thead class="thead-dark">
                <th hidden scope="col">Id</th>
                <th scope="col">{{ $t('outOfSpecificationTableIndicator') }}</th>
                <th class="text-center" scope="col">{{ $t('outOfSpecificationTableReal') }}</th>
                <th class="text-center" scope="col">{{ $t('outOfSpecificationTableForeseen') }}</th>
                <th class="text-center" scope="col">{{ $t('outOfSpecificationTableAdherence') }}</th>
                <th class="text-center" scope="col" style="display:none">{{ $t('outOfSpecificationTableWeight') }}</th>
                <th class="text-center" scope="col">{{ $t('outOfSpecificationTableOccurrences') }}</th>
              </thead>
              <tbody>
                <template v-if="this.indicators.length != 0">
                  <tr :class="`indicator-${indicator.id}`" v-for="indicator in this.filteredIndicators"
                    :key="indicator.id" @dblclick.stop="setSelectedIndicator">
                    <td hidden>{{ indicator.id }}</td>
                    <td>{{ indicator.name }}</td>
                    <td class="text-center">
                      {{ ParseNumber(indicator.value) }}
                    </td>
                    <td class="text-center">
                      {{ ParseNumber(indicator.target) }}
                    </td>
                    <td class="text-center">{{ ParseNumber(indicator.reliability) }}</td>
                    <td class="text-center" style="display:none">{{ indicator.weight }}</td>
                    <td class="text-center">{{ indicator.occurrences }}</td>
                  </tr>
                </template>
                <tr v-else>
                  <td colspan="6">{{ $t('noDataUnitIndicated') }}</td>
                </tr>
              </tbody>
            </table>

          </div>
        </div>
      </div>
    </section>
    <!-- /SELECIONE UM INDICADOR -->

    <!-- OCORRENCIAS -->
    <span v-if="indicatorId != -9999">
      <!-- CRIAR OCORRENCIAS -->
      <section class="mt-3" v-if="!hasOccurrences">
        <div class="mb-3">
          <p class="h6">{{ $t('insertAOccurrence') }}</p>
        </div>

        <div class="occurrence-insertion">
          <div class="responsible-config">
            <div class="responsible-list">
              <label for="responsible-select">{{ $t('responsibleForOccurrence') }}</label>
              <SearchableSelect
                id="responsible-select"
                class="form-control"
                :extraClass="'input-pentagro'"
                :modelRef="responsibleKey"
                :optList="responsibleOptions"
                optValue="value"
                optDisplay="text"
                :inputFunc="updateResponsibleKey"
                :placeholder="$t('selectAResponsible')"
              />
            </div>

            <SelectOrigin v-if="indicatorId" class="mt-3"
              :selected="{ processId: this.processId, processName: this.processName, equipmentId: this.equipmentId, equipmentName: this.equipmentName, productId: this.productId, productName: this.productName }"
              :editable="true" @selectedProcess="processId = $event" @selectedEquipment="equipmentId = $event"
              @selectedProduct="productId = $event" @selectedProcessName="processName = $event"
              @selectedEquipmentName="equipmentName = $event" @selectedProductName="productName = $event" />


            <div>
              <div class="reasonTitle">
                <p>{{ $t('reason-and-action') }}</p>
                <button @click.stop.prevent="() => $bvModal && $bvModal.show('selectReasonTreeWorkShift')">
                  <span>{{ $t('add-reason') }}</span>
                  <b-icon-plus-circle-fill></b-icon-plus-circle-fill>
                </button>
              </div>
              <div v-if="this.reasonsList.length > 0" class="reasonActionContainer">
                <details v-for="(reason, idx) in this.reasonsList" :key="`reason-${idx}-${Math.random()}`">
                  <summary>
                    <span :title="reason.title">{{ reason.title }}</span>
                    <button v-if="true" @click="openRemoveModal('deleteReasonModal', idx, null)" class="removeReasonBtn"
                      :title="$t('remove-reason')">
                      <!-- <span>{{ $t('remove-reason') }}</span> -->
                      <b-icon-trash-fill />
                    </button>
                  </summary>
                  <article>
                    <div class="actionsContainer" v-if="reason.actions.length > 0">
                      <div v-for="(action, acIdx) in reason.actions" :key="`actions-${acIdx}-${Math.random()}`">
                        <div class="actionItem">
                          <div class="actionTitle">
                            <strong> {{ $t('actionTableActionHeader') }}:</strong>
                            <span :title="action.action">{{ action.action }}</span>
                          </div>
                          <div>
                            <strong>{{ $t('actionTableResponsibleHeader') }}:</strong>
                            <span :title="action.responsableName">{{ action.responsableName }}</span>
                          </div>
                          <div v-if="true">
                            <strong>{{ $t('actionTableDeadlineHeader') }}:</strong>
                            <span>{{ formatOccDate(action.date) }}</span>
                          </div>
                          <div v-else>
                            <strong>{{ $t('conclusion') }}:</strong>
                            <span>{{ formatOccDate(action.closingDate).split('-')[0].trim() }}</span>
                          </div>
                          <div>
                            <div v-if="true">
                              <strong>{{ $t('status-0') }}:</strong>
                              <span>{{ action.status }}</span>
                            </div>
                            <div v-else class="actionBtn">
                              <b-icon-trash-fill v-if="true" @click="openRemoveModal('deleteActionModal', idx, acIdx)"
                                title="Remover Ação"></b-icon-trash-fill>
                              <b-icon-pencil-fill v-if="true" title="Editar Ação"
                                @click="openActionModal(reason, action)"></b-icon-pencil-fill>
                              <b-icon-check-circle-fill v-if="true" @click="openConfirmAction(idx, acIdx)"
                                title="Concluir Ação"></b-icon-check-circle-fill>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <p class="voidActions" v-else>{{ $t('no-action-on-reason') }}</p>
                    <button v-if="true" class="addActionBtn" @click.stop.prevent="openActionModal(reason, null)">
                      <span>{{ $t('addActionButtom') }}</span>
                      <b-icon-plus-circle-fill></b-icon-plus-circle-fill>
                    </button>
                  </article>
                </details>

              </div>
              <p v-else>{{ $t('no-reason-found') }}</p>
            </div>

            <div class="groupBtn mr-7 mt-3">
              <img src="@/assets/cancel.png" alt="Confirmar" style="margin-left: 20px;" :title="$t('clearFieldsButtom')"
                v-b-modal.messageBox />

              <img id="save-ocurrence-button" class="ml-3" @click="save" src="../../assets/salvar.png"
                :title="$t('createOccurrenceButtom')" alt="salvar_ocorrencia" />
            </div>
          </div>
        </div>
      </section>
      <!-- / CRIAR OCORRENCIAS -->

      <!-- OCORRENCIAS RELACIONADAS -->
      <section class="mt-3">
        <div class="row occurrences mt-3">
          <div class="col-12">
            <p class="h6">{{ $t('relatedOcorrencesHeader') }}</p>
            <div class="div-table">
              <table class="table table-hover table-striped">
                <thead class="thead-dark">
                  <th scope="col">{{ $t('reasonsHeader') }}</th>
                  <th class="text-center" scope="col">{{ $t('dateHeader') }}</th>
                  <th class="text-center" scope="col">{{ $t('deadlineHeader') }}</th>
                </thead>
                <tbody>
                  <template v-if="this.indicatorOcurrences.length != 0">
                    <tr v-for="(occurrence, index) in this.indicatorOcurrences" :key="occurrence.id"
                      @click="onRowClick(index)">
                      <td>{{ occurrence.description }}</td>
                      <td class="text-center">
                        {{ occurrence.baseDate | occurrenceDate }}
                      </td>
                      <td class="text-center">
                        {{ (occurrence.deadline.includes("1900-01-01") ? "-" : occurrence.deadline) | occurrenceDate }}
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
      <!-- / OCORRENCIAS RELACIONADAS -->
    </span>
    <!-- / OCORRENCIAS -->

    <!-- BOTÕES DA BASE -->
    <hr>
    <b-row class="groupBtn">
      <div>
        <img id="closeModalPassword" class="float-right" src="@/assets/sair.png" style="margin-left: 30px;"
          :title="$t('cancel')" alt="cancelar" @click="$bvModal.hide('workShiftClosing')" />
      </div>
    </b-row>
    <!--/ BOTÕES DA BASE -->

    <b-modal id="messageBox" size="md" hide-footer :title="$t('atention')" :no-close-on-backdrop="true" @hidden="isModalOpen = false">
      <MessageBox :question="$t('confirmClearOccurrenceFields')" v-bind:action="confirmClearFieldsOccurrence"
        modelname="messageBox" />
    </b-modal>

    <b-modal id="confirmDuplicateOccurrence" size="md" hide-footer :title="$t('atention')" :no-close-on-backdrop="true" @hidden="isModalOpen = false">
      <MessageBox :info="$t('confirmDuplicateOccurrenceMessage')" modelname="confirmDuplicateOccurrence" />
    </b-modal>

    <b-modal id="WorkShiftOccurrenceEditor" size="xl" hide-footer @hidden="handleModalClose">
      <div slot="modal-title" class="img-slot">
        <img style="width: 33px; height: 33px; margin-right: 10px;" src="@/assets/circular138.png"
          alt="salvar_ocorrencia" />
        {{ $t('occurrenceEditorModal') }}
      </div>

      <ManageAllOccurrences :indicatorInfo="null" :occurrenceInfo="occurrenceSelected"
        :reloadOccFunct="loadIndicatorOccurrences" :otherOccurrencesInfo="indicatorOcurrences"
        parentModalId="WorkShiftOccurrenceEditor" />
    </b-modal>

    <b-modal size="lg" hide-footer :title='$t("selectReasonModal")' id="selectReasonTreeWorkShift" @hidden="isModalOpen = false">
      <ReasonsToSelect :reasonTree="reasonTree" :addReasonFunction="addReasonToList" :userObj="user">
      </ReasonsToSelect>
    </b-modal>

    <b-modal size="lg" hide-footer :title='$t("selecione-uma-acao")' id="selectActionTreeWorkShift" @hidden="isModalOpen = false">
      <ActionsToSelect :indicatorId="indicatorId ? indicatorId : null" :userObj="user"
        :reasonTreeId="currentReasonTreeId" :reasonId="currentReasonId" :addActionFunction="addActionToList"
        :responsiblesList="responsibleList" :actionObj="editingAction" :showActionResponsible="false"
        :occurrenceResponsible="null" :needDeadline="needDeadline"></ActionsToSelect>
    </b-modal>

    <b-modal id="deleteReasonModal" title="Remover Motivo" ok-variant=danger :ok-title="$t('yes')"
      :cancel-title="$t('no')" @ok="removeReason" @hidden="isModalOpen = false">
      <p>{{ $t('confirm-remove-reason') }}</p>
    </b-modal>

    <b-modal id="deleteActionModal" title="Remover Ação" ok-variant=danger :ok-title="$t('yes')"
      :cancel-title="$t('no')" @ok="removeAction" @hidden="isModalOpen = false">
      <p>{{ $t('confirm-remove-action') }}</p>
    </b-modal>

    <b-modal id="confirmActionModal" title="Concluir Ação" ok-variant=danger :ok-title="$t('yes')"
      :cancel-title="$t('no')" @ok="confirmAction" @hidden="isModalOpen = false">
      <p>{{ $t('confirm-finish-action') }}</p>
    </b-modal>

  </div>
</template>

<script>
import { urlMainAPI, showError, defaultSuccess } from "@/global";
import { OccurrenceMixin } from "../occurrence/occurrenceMixin";
import { mapState } from "vuex";
import MessageBox from "@/components/template/MessageBoxModal.vue";
// eslint-disable-next-line no-unused-vars
import * as moment from "moment";
import axios from "axios";
import { FiltersMixin } from "../mixins/filtersMixin";
import { WaitMixin } from "../mixins/waitMixin";
import SelectOrigin from "@/components/occurrence/selectOrigin.vue";
import ManageAllOccurrences from "../manageAllOccurrences/ManageAllOccurrences.vue";
// Importação da função getLDCSystem comentada pois não está mais em uso
// import { getLDCSystem } from '../../global';
import ReasonsToSelect from "../manageAllOccurrences/utils/ReasonsToSelect.vue";
import ActionsToSelect from "../manageAllOccurrences/utils/ActionsToSelect.vue";
import { faultTreeMixin } from '../mixins/faultTreeMixin'
import SearchableSelect from "@/components/rta/commons/SearchableSelect.vue";

export default {
  name: "WorkShiftClosing",

  mixins: [OccurrenceMixin, FiltersMixin, WaitMixin, faultTreeMixin],

  components: {
    MessageBox,
    SelectOrigin,
    ManageAllOccurrences,
    ReasonsToSelect,
    ActionsToSelect,
    SearchableSelect
  },

  computed: {
    ...mapState(["user"]),
    productionDateISO: {
      get() {
        if (!this.productionDate) return '';
        if (typeof this.productionDate === 'object' && this.productionDate.format) {
          return this.productionDate.format('YYYY-MM-DD');
        }
        return '';
      },
      set(val) {
        this.productionDate = val ? moment(val, 'YYYY-MM-DD') : moment();
      }
    },
    hasOccurrences() {
      const selectedIndicator = this.indicators.find(ind => ind.id === this.indicatorId);
      return selectedIndicator && selectedIndicator.occurrences > 0;
    },
    responsibleOptions() {
      const options = [
        { value: "-1", text: this.$t('selectAResponsible') }
      ];
      if (this.responsibleList && this.responsibleList.length > 0) {
        this.responsibleList.forEach(responsible => {
          options.push({
            value: `${responsible.id}-${responsible.unitId}-${responsible.system}`,
            text: responsible.name
          });
        });
      }
      return options;
    }
  },

  data() {
    return {
      isModalOpen: false,
      actions: [],
      selectedWorkshift: 1,
      areaList: [],
      showForm: true,
      monitoringGroup: null,
      filter: null,
      indicators: [],
      filteredIndicators: [],
      processedIndicatorIds: [],
      indicatorOcurrences: [],
      occurrenceSelected: {},
      occurrenceDescription: "",
      occurrenceObservation: "",
      clickedOnTable: false,
      loadingReport: false,
      enableWorkOrder: false,
      workOrderOccurrence: "",
      workeOrder: "",
      // Flag que controla a exibição da mensagem de aviso para usuários LDC
      // isLDC: false,
      openSpecifyType: false,
      openTriggerType: false,
      reasonsList: [],
      reasonTree: {},
      deletingActionIdx: null,
      deletingReasonIdx: null,
      confirmingReasonIdx: null,
      confirmingActionIdx: null,
      editingAction: {},
      needDeadline: false,
      currentReasonId: null,
      currentReasonTreeId: null,
      reasonContent: "",
      workshiftDescriptions: {
        1: "",
        2: "", 
        3: "",
        4: ""
      }
    }
  },

  watch: {
    filter() {
      this.applyFilters();
    },

    openSpecifyType() {
      this.applyFilters();
    },

    openTriggerType() {
      this.applyFilters();
    },

    selectedWorkshift() {
      this.clearIndicators()
    },

    productionDate() {
      this.clearIndicators()
    },

    occurrenceDescription() {
      this.setEnableWorker()
    },
  },

  filters: {
    occurrenceDate(date) {
      if (!date || date == "-") return date
      let occurenceDate = date.split(" ")[0];
      occurenceDate = occurenceDate.split("-").reverse();
      occurenceDate = occurenceDate.join("/");
      return occurenceDate;
    },
  },

  methods: {
    applyFilters() {
      const filterText = (this.filter || '').toUpperCase();
      const hasTrigger = this.openTriggerType;
      const hasAdherence = this.openSpecifyType;

      this.filteredIndicators = this.indicators.filter((indicator) => {
        if (!indicator) return false;

        const matchesName = indicator.name.toUpperCase().includes(filterText);
        if (!matchesName) return false;

        // Nenhum filtro ativo ou ambos ativos → mostra todos
        if (hasTrigger === hasAdherence) return true;

        const occ = Number(indicator.occurrences) || 0;

        // Apenas "Aberta por Gatilhos" → tem ocorrências
        if (hasTrigger && !hasAdherence) return occ > 0;

        // Apenas "Fora da Meta de Aderência" → aderência abaixo da meta individual
        if (!hasTrigger && hasAdherence) {
          const rel = parseFloat(indicator.reliability);
          const meta = parseFloat(indicator.reliabilityTarget);
          return !isNaN(rel) && !isNaN(meta) && rel < meta;
        }

        return true;
      });
    },

    updateResponsibleKey(event) {
      this.responsibleKey = event.target.value;
      this.setResponsible();
    },

    async save() {
      if (this.enableWorkOrder && !this.workOrderOccurrence) {
        showError(this.$t('campo-ordem-de-servico-e-obrigatorio'));
        return;
      }
      this.reasonContent;
      this.waitOn();
      this.workshiftId = this.selectedWorkshift;
      this.reasonContent = JSON.stringify(this.reasonContent);

      if (this.reasonsList.length > 0) {
        this.occurrenceDescription = "";
        this.reasonsList.forEach(item => {
          this.occurrenceDescription += `${item.title};`
        })
      }

      defaultSuccess(this.$t('salvando-ocorrencia'))
      await this.saveOccurrence();
      if (this.canSave) {
        defaultSuccess(this.$t('ocorrencia-salva-com-sucesso'))
        this.confirmClearFieldsOccurrence();
        this.indicatorId = -9999;
        let selectedTr = document.querySelector(".indicator-selected");
        if (selectedTr) selectedTr.classList.remove("indicator-selected");
      }
      this.waitOff();
    },

    confirmClearFieldsOccurrence() {
      this.occurrenceDescription = "";
      this.occurrenceObservation = "";
      this.responsibleId = -1;
      this.responsibleKey = -1
      this.indicatorOcurrences = [];
      this.deadline = 0;
      this.progress = 1;
      this.reasonsList = [];
      this.deletingActionIdx = null;
      this.deletingReasonIdx = null;
      this.confirmingReasonIdx = null;
      this.confirmingActionIdx = null;
      this.editingAction = {};
      this.currentReasonId = null;
      this.currentReasonTreeId = null;
      this.reasonContent = "";
      this.cleanActions++;
      
      this.processId = null;
      this.processName = null;
      this.equipmentId = null;
      this.equipmentName = null;
      this.productId = null;
      this.productName = null;
    },

    async getTreeAreaList() {
      this.wait = true;
      const url = `${urlMainAPI}/getmonitoringgroupslist`;
      await axios.get(url).then((res) => {
        if (res.data)
          this.areaList = res.data

        this.wait = false;
      }).catch(e => { console.log(e); this.wait = false });
    },

    async loadOccurrenceConfig() {
      let baseDate = this.formatBaseDate(this.productionDate);

      let obj = {
        unitId: parseInt(this.user.UnitId),
        system: this.user.role == "PGDI" ? "P" : "G",
        baseDate: baseDate,
        monitoringGroup: this.monitoringGroup,
        workshift: parseInt(this.selectedWorkshift),
      }

      if (obj.monitoringGroup == null) {
        showError(this.$t('por-favor-selecione-um-processo-valido'))
        return
      }

      this.loadingReport = true

      this.waitOn();
      defaultSuccess(this.$t('carregando-indicadores-nao-aderentes'));
      await axios.post(`${urlMainAPI}/getworkshiftnonreliabilityindicator/`, obj).then((res) => {
        if (res.status == 200 && res.data.length > 0) {
          // Mantém os indicadores existentes que têm ocorrências > 0 ou que estão sendo tratados
          const existingIndicators = this.indicators.filter(indicator => 
            indicator.occurrences > 0 || 
            (indicator.id === this.indicatorId && this.reasonsList.length > 0)
          );
          
          // Atualiza os indicadores existentes com os dados mais recentes
          res.data.forEach(newIndicator => {
            const existingIndicator = existingIndicators.find(ind => ind.id === newIndicator.id);
            if (existingIndicator) {
              Object.assign(existingIndicator, newIndicator);
            } else {
              existingIndicators.push(newIndicator);
            }
          });

          this.indicators = existingIndicators;
          this.indicators.sort((a, b) => (a.weight + a.occurrences) > (b.weight + b.occurrences) ? -1 : (a.weight + a.occurrences) < (b.weight + b.occurrences) ? 0 : 1);
          this.filteredIndicators = this.indicators;
          defaultSuccess(this.$t('indicadores-carregados-com-sucesso'));
        }
        else
          showError(this.$t('sem-dados-na-data-indicada-ou-turno-escolhido'));
        this.waitOff();
      }).catch(e => { console.log(e); this.waitOff(); });

      this.loadingReport = false
    },

    setSelectedIndicator(event) {
      const tr = event.target.parentElement;
      let indicatorId = tr.className.split("-")[1];

      let previousTr = document.querySelector(".indicator-selected");
      if (previousTr) previousTr.classList.remove("indicator-selected");

      tr.classList.add("indicator-selected");
      this.indicatorId = isNaN(Number(indicatorId)) ? this.indicatorId : Number(indicatorId);

      if (this.indicatorId >= 1) {
        defaultSuccess(this.$t('indicador-selecionado'));
        this.eraseOccurrenceFieds();
        this.loadIndicatorOccurrences();
        this.getFaultTreeByIndicatorId(this.indicatorId, this.user);
        
        this.responsibleKey = "-1";
        this.processId = null;
        this.processName = null;
        this.equipmentId = null;
        this.equipmentName = null;
        this.productId = null;
        this.productName = null;
      }
    },

    async loadIndicatorOccurrences() {
      let baseDate = this.formatBaseDate(this.productionDate);

      let getOccurrence = {
        id: this.indicatorId,
        baseDate: baseDate,
        productionUnitId: parseInt(this.user.UnitId),
        system: this.system,
        workshiftId: parseInt(this.selectedWorkshift)
      };

      const url = `${urlMainAPI}/getrelatedoccurrenceindicator`;
      await axios.post(url, getOccurrence)
        .then(res => {
          this.indicatorOcurrences = res.data;
          this.buildReasonActionStructure(this.indicatorOcurrences);
        }).catch(console.log)

    },

    async getWorOrderInOccurrence() {
      const url = `${urlMainAPI}/getsystemconfiguration`;
      await axios.get(url)
        .then((res) => {
          this.workeOrder = res.data.workOrderInOccurrence
        })
        .catch();
    },

    setEnableWorker() {
      if (this.occurrenceDescription && this.occurrenceDescription.toLowerCase().includes("manutenção") && this.workeOrder)
        this.enableWorkOrder = true;
      else
        this.enableWorkOrder = false;
    },

    eraseOccurrenceFieds() {
      this.occurrenceDescription = null;
      this.occurrenceObservation = "";
      this.responsibleId = -1;
      this.responsibleKey = -1
      this.indicatorOcurrences = [];
      this.deadline = 0;
      this.progress = 1;
      this.cleanActions++
      this.actions = []
    },

    onRowClick(indice) {
      if (this.clickedOnTable) {
        let occurrence = this.indicatorOcurrences[indice]
        if (occurrence) {
          this.occurrenceSelected = { ...occurrence }

          if ((!this.occurrenceSelected.workshiftDescription || this.occurrenceSelected.workshiftDescription == undefined) && this.occurrenceSelected.workshift) {
            this.occurrenceSelected.workshiftDescription = this.workshiftDescriptions[this.occurrenceSelected.workshift] || this.$t('dayTurn');
          }

          if (this.$bvModal && !this.isModalOpen) {
            this.isModalOpen = true;
            this.$bvModal.show("WorkShiftOccurrenceEditor");
          }
        }
      }
      else {
        this.clickedOnTable = true;
        this.dbClickTimer()
      }
    },

    dbClickTimer() { setTimeout(() => { this.clickedOnTable = false }, 400) },

    clearIndicators() {
      this.indicators = new Array();
      this.indicatorId = -9999
      this.eraseOccurrenceFieds()
    },

    formatDate(date) {
      const d = new Date(date);
      let month = '' + (d.getMonth() + 1);
      let day = '' + d.getDate();
      const year = d.getFullYear();

      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;

      return [year, month, day].join('-');
    },

    buildReasonActionStructure(occurrence) {
      if (!occurrence || occurrence.length == 0) return;

      for (let occ of occurrence) {
        if (occ.content && occ.content != "" && occ.content != null && occ.content != undefined) occ.content = JSON.parse(occ.content)
        if (occ.reasonContent && occ.reasonContent != "" && occ.reasonContent != null && occ.reasonContent != undefined) {
          occ.reasonContent = JSON.parse(occ.reasonContent)
        }

        this.reasonContent = occ.reasonContent;
      }
    },

    async getFaultTreeByIndicatorId(indicatorId, userObj) {
      await axios
        .get(`${urlMainAPI}/getfaulttree/${indicatorId}/${userObj.UnitId}/${userObj.onlineType[0]}`)
        .then((res) => {
          if (res.data) {
            this.reasonTree = this.copyFrom(res.data);

            if (this.reasonTree.state && this.reasonTree.state.expanded) this.reasonTree.state.expanded = true;
          }
        })
        .catch(err => console.error(err));
    },

    addReasonToList(reasonObj) {
      let reasonAlreadyAdded = this.reasonsList.find(item => item.title == reasonObj.title);

      if (reasonAlreadyAdded != null) {
        this.$bvToast.toast('Motivo duplicado não adicionado!', {
          title: 'O motivo selecionado já existe na lista.',
          variant: 'warning',
          toaster: 'b-toaster-bottom-left',
          solid: true
        });

        return;
      }

      this.reasonsList.push(reasonObj);
      this.setReasonContent(this.reasonsList);

      if (this.$bvModal) {
        this.$bvModal.hide('selectReasonTreeWorkShift');
      }
    },

    formatOccDate(dateStr, withoutHour) {
      if (dateStr == null || dateStr == undefined || dateStr.includes("/")) return dateStr

      let dtObj = new Date(dateStr);

      let dateFormat = ("0" + dtObj.getDate()).slice(-2);
      let monthFormat = ("0" + (dtObj.getMonth() + 1)).slice(-2);

      let formattedString = `${dtObj.getFullYear()}/${monthFormat}/${dateFormat}`;

      if (dateStr.includes(":") && (withoutHour == undefined || withoutHour == null || withoutHour == true)) {
        let hourFormat = ("0" + dtObj.getHours()).slice(-2);
        let minuteFormat = ("0" + dtObj.getMinutes()).slice(-2);
        let secondFormat = ("0" + dtObj.getSeconds()).slice(-2);
        formattedString += ` - ${hourFormat}:${minuteFormat}:${secondFormat}`;
      }

      return formattedString;
    },

    openRemoveModal(modalText, reasonIdx, actionIdx) {
      this.deletingReasonIdx = reasonIdx;
      this.deletingActionIdx = actionIdx;
      if (this.$bvModal) {
        this.$bvModal.show(modalText);
      }
    },

    openConfirmAction(reasonIdx, actionIdx) {
      this.confirmingReasonIdx = reasonIdx;
      this.confirmingActionIdx = actionIdx;
      if (this.$bvModal) {
        this.$bvModal.show("confirmActionModal")
      }
    },

    openActionModal(reasonObj, editingObj) {
      if (this.isModalOpen) return;
      
      if (editingObj != null) {
        this.editingAction = editingObj;
      }

      this.currentReasonId = reasonObj.id;
      this.currentReasonTreeId = reasonObj.reasonTreeId;
      
      if (this.$bvModal) {
        this.isModalOpen = true;
        this.$bvModal.show("selectActionTreeWorkShift");
      }
    },

    addActionToList(actionToAdd, reasonId) {
      this.reasonsList.forEach(item => {
        if (item.id == reasonId) {
          let actionFound = item.actions.findIndex(ac => ac.id == actionToAdd.actionId || ac.actionId == actionToAdd.actionId);

          if (actionFound == -1) {
            item.actions.push(actionToAdd)
          } else {
            item.actions.splice(actionFound, 1, actionToAdd)
          }
        }
      });

      let actionsFormatted = {
        action: actionToAdd.action,
        date: actionToAdd.date,
        name: actionToAdd.name,
        responsible: {
          id: actionToAdd.responsableId,
          responsableUnitId: actionToAdd.responsableUnitId,
          responsableSystem: actionToAdd.responsableSystem,
        }
      }

      this.actions.push(actionsFormatted)

      this.checkFinishStatus++;

      this.editingAction = {};

      this.setReasonContent(this.reasonsList);

      if (this.$bvModal) {
        this.$bvModal.hide('selectActionTreeWorkShift');
      }
    },

    removeReason() {
      if (this.deletingReasonIdx != null) {
        this.reasonsList.splice(this.deletingReasonIdx, 1);
      }

      this.deletingReasonIdx = null;
      this.deletingActionIdx = null;

      this.checkFinishStatus++;

      this.setReasonContent(this.reasonsList);
    },

    removeAction() {
      if (this.deletingReasonIdx != null && this.deletingActionIdx != null) {
        this.reasonsList[this.deletingReasonIdx].actions.splice(this.deletingActionIdx, 1);
      }

      this.deletingReasonIdx = null;
      this.deletingActionIdx = null;

      this.checkFinishStatus++;

      this.setReasonContent(this.reasonsList);
    },

    confirmAction() {
      if (this.confirmingReasonIdx != null && this.confirmingActionIdx != null) {
        this.$set(this.reasonsList[this.confirmingReasonIdx].actions[this.confirmingActionIdx], 'status', "Concluída");
        let closingDate = new Date().toLocaleDateString("pt-BR");
        this.$set(this.reasonsList[this.confirmingReasonIdx].actions[this.confirmingActionIdx], 'closingDate', closingDate);
      }

      this.confirmingReasonIdx = null;
      this.confirmingActionIdx = null;

      this.checkFinishStatus++;
      this.$forceUpdate();

      this.setReasonContent(this.reasonsList);
    },

    setReasonContent(reasons) {
      if (typeof this.reasonContent == "string" || this.reasonContent == null || this.reasonContent == undefined) {
        this.reasonContent = {
          reasons: reasons
        }
      } else {
        this.reasonContent.reasons = reasons;
      }
    },

    async loadWorkshiftDescriptions() {
      try {
        const response = await axios.get(`${urlMainAPI}/getworkshift`);
        if (response.data && response.data.length > 0) {
          const newDescriptions = {...this.workshiftDescriptions};
          response.data.forEach(shift => {
            if (shift.id >= 1 && shift.id <= 4) {
              newDescriptions[shift.id] = shift.description;
            }
          });
          this.workshiftDescriptions = newDescriptions;
        }
      } catch (error) {
        console.error('Erro ao carregar descrições dos turnos:', error);
      }
    },

    async handleModalClose() {
      this.isModalOpen = false;
      await this.loadIndicatorOccurrences();
    },

  },
  created() {
    this.getWorOrderInOccurrence();
    this.loadWorkshiftDescriptions();
  },

  async mounted() {
    this.productionUnit = { id: parseInt(this.user.UnitId) }
    this.productionDate = moment();
    this.getTreeAreaList();
    this.loadResponsibleList();
    // Inicialização da flag isLDC através da função getLDCSystem
    // this.isLDC = getLDCSystem();

    this.needDeadline = this.user && this.user.Permissions && this.user.Permissions.criaracaocomprazo && this.user.Permissions.criaracaocomprazo.allowed == true;
  },

  destroyed() { this.wait = false },
}
</script>
<style scoped>
.main {
  padding: 0 8px 8px 8px;
}

.info-ldc {
  font-style: bold;
  color: #FF0000;
  display: flex;
}

#search-button {
  width: 65px;
  height: 65px;
  max-height: 65px;
  padding: 10px;
  cursor: pointer;
}

.select-Indicators {
  width: 85%;
  display: flex;
  flex-direction: column;
}

.sru-date-input {
  padding: 6px 10px;
  border: 1px solid #ff6600;
  border-radius: 4px;
  font-size: 14px;
  width: 100%;
}


.d-flex {
  display: flex;
  align-items: baseline;
  justify-items: flex-start;
}

.occurrence-date {
  display: grid;
  grid-template-columns: 60% 25% 15%;
  align-items: center;
  justify-items: flex-start;
}

section {
  border-radius: 4px;
  box-shadow: 1px 1px 4px 1px #00000050;
  padding: 8px;
  /* margin: 2px; */
}

section div h1 {
  font-size: 1.5rem;
  padding: 0.3rem 0.2rem;
}

label {
  font-weight: 500;
}

.filtersContent {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 0.3rem;
}

.filtersContent .selectors div {
  display: flex;
  align-items: center;
  column-gap: 1rem;
}

.reasonTitle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0.4rem 0;
}

.reasonTitle p {
  font-weight: bold;
  margin: 0;
  font-size: 1.1rem;
}

.reasonTitle button,
article button {
  background-color: #ff5f00;
  color: white;
  font-weight: bold;
  border: 1px solid #ff5f00;
  border-radius: 0.2rem;
  font-size: 1rem;

  display: flex;
  align-items: center;
  column-gap: 0.4rem;
}

article {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  border: 1px solid gray;
  padding: 0.1rem;
}

article button {
  align-self: center;
  justify-self: center;
}

.reasonTitle button svg,
article button svg {
  color: #006F6F;
  stroke: white;
}

.reasonActionContainer {
  display: flex;
  flex-direction: column;
  width: 100%;
  row-gap: 0.5rem;
  overflow-y: auto;
  max-height: 10rem;
}

summary {
  list-style: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.2rem 0.4rem;
  font-weight: bold;
  background-color: black;
  color: white;
  position: relative;
  column-gap: 1rem;
}

summary::after {
  content: "Visualizar Ações \02C3";
  transition: 0.2s;
  font-size: 0.9rem;
  background-color: #ff5f00;
  color: #fff;
  border-radius: 0.2rem;
  padding: 0.1rem 0.6rem;
}

details[open] summary::after {
  content: "Visualizar Ações \02C5";
  transition: 0.2s;
  font-size: 0.9rem;
  background-color: #ff5f00;
  color: #fff;
  border-radius: 0.2rem;
  padding: 0.1rem 0.6rem;
}

summary span {
  max-width: 70%;
  overflow: hidden;
  text-overflow: ellipsis;
  text-wrap: nowrap;
}

.removeReasonBtn {
  display: block;
  margin-left: auto;
  font-size: 0.9rem;
  font-weight: bold;
  background-color: #FF1F1F;
  border: none;
  border-radius: 0.2rem;
  color: white;
  cursor: pointer;
}

.removeReasonBtn span {
  margin-right: 0.2rem;
}

.addActionBtn {
  margin: 0.2rem 0;
}

.actionsContainer {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
}

.actionsContainer div {
  width: 100%;
}

.actionItem {
  width: 100%;
  border-bottom: 1px solid gray;

  display: grid;
  grid-template-columns: 3fr 2fr 1fr 1fr;
  align-items: center;
  padding: 0.1rem 0.2rem;
  column-gap: 0.5rem;
}

.actionItem strong {
  font-weight: bold;
  color: #ff5f00;
  margin-right: 0.2rem;
  font-size: 0.9;
}

.actionItem span {
  font-weight: normal;
  font-size: 0.9rem;
  color: rgb(59, 59, 59);
}

.actionItem .actionTitle {
  max-width: 95%;
  overflow: hidden;
  text-overflow: ellipsis;
  text-wrap: nowrap;
}

.voidActions {
  margin: 0;
  padding: 0 0.2rem;
  text-align: left;
  width: 100%;
  border-bottom: 1px solid gray;
}

.actionBtn {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  column-gap: 1.4rem;
}

.actionBtn svg {
  font-size: 1.15rem;
  fill: #ff5f00;
  cursor: pointer;
}









.unit-production-config>select {
  min-width: 100px;
}

.div-table {
  min-height: 100px;
  max-height: 220px;
  overflow: auto;
}

table th {
  position: -webkit-sticky;
  position: sticky;
  top: -1px;
  z-index: 1;
  background: #fff;
}

table td:hover,
#save-ocurrence-button,
#search-button {
  cursor: pointer;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

table tr.indicator-selected {
  background-color: rgba(65, 67, 69, 0.65) !important;
  color: white;
}

.row-table-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.action-table {
  min-height: 150px;
}

.table-wrapper-scroll-y {
  display: block;
}

.reason-button {
  margin-left: 10px;
  width: 100px;
  border: 1px solid;
  color: white;
  background-color: #ff5f00;
  border-radius: 8px;
  font-weight: 500;

}

.row-flex {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

#description {
  width: 885px;
}

.deadline-config {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

textarea {
  border: 2px solid #343a40;
  border-radius: 5px;
}

.spinnerConfig {
  width: 1.5rem;
  height: 1.5rem;
  margin-left: 10px;
  color: #ff5f00;
}

.seachButtonGroup {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  min-width: 55px;
}

@media only screen and (max-width: 1199px) {
  .responsible-config {
    max-width: 900px;
  }

  .occurrence-insertion textarea {
    max-width: 720px;
  }

  #description {
    width: 570px;
  }
}

@media only screen and (max-width: 991px) {
  #description {
    width: 270px;
  }

  .responsible-config {
    max-width: 900px;
  }

  .occurrence-insertion textarea {
    max-width: 510px;
  }

  .container,
  .container-sm,
  .container-md {
    max-width: 915px;
  }

  .col-12 {
    max-width: 98.5%;
  }
}

@media only screen and (max-width: 770px) {
  .occurrence-insertion {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 50% 50%;
  }

  .container,
  .container-sm,
  .container-md {
    max-width: 857px;
  }

  .occurrence-insertion textarea {
    position: relative;
    height: 100px;
    max-width: 530px;
  }

  .occurrence-date {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
  }

  .select-Indicators {
    grid-row-start: 1;
    grid-column: 1 / spam 2;
  }

  .select-workshift {
    grid-row-start: 2;
    grid-column-start: 1;
  }

  #search-button {
    grid-row-start: 2;
    grid-column-start: 2;
    width: 50px;
    height: 50px;
  }


  .date-item {
    min-width: 500px;
  }

  .unit-production-config {
    min-width: 520px;
  }

  .responsible-list {
    margin-right: 5px;
    margin-top: 15px;
  }

  #description {
    width: 250px;
  }
}

@media only screen and (max-width: 548px) {
  .responsible-config {
    min-width: 350px;
  }

  .occurrence-insertion textarea {
    max-width: 350px;
  }

  #save-ocurrence-button {
    align-self: flex-end;
  }
}

@media only screen and (max-width: 530px) {
  .date-item {
    min-width: 360px;
  }

  .unit-production-config {
    min-width: 340px;
  }

  .unit-production-config label {
    margin-right: 25px;
  }

  .unit-production-config select {
    min-width: 208px;
  }

  #description {
    width: 170px;
  }

  .select-reason {
    display: block;
  }

  .reason-button {
    height: 100px;
    align-self: end;
    margin-bottom: 5px;
  }

  .responsible-config {
    min-width: 238px;
  }

  .row-table-button {
    min-width: 256px;
  }

  #description {
    width: 290px;
  }

  .deadline-config {
    align-items: center;
    justify-content: space-around;
  }
}

@media only screen and (max-width: 484px) {
  #description {
    width: 200px;
  }
}


@media only screen and (max-width: 390px) {
  .date-item {
    min-width: 315px;
  }

  .occurrences {
    margin-right: -5px;
    margin-left: -5px;
  }

  .unit-production-config select {
    min-width: 164px;
  }

  .unit-production-config label {
    margin-right: 5px;
  }

  .responsible-config {
    min-width: 270px;
  }

  .occurrence-insertion textarea {
    max-width: 300px;
  }

  .col-12 {
    max-width: 96.5%;
  }

  #description {
    width: 170px;
  }

  .select-reason {
    display: block;
  }

  .reason-button {
    height: 100px;
    align-self: end;
    margin-bottom: 5px;
  }

  .responsible-config {
    min-width: 238px;
  }

  .row-table-button {
    min-width: 256px;
  }

}
</style>